import { RequestOptions } from '../common/models/GenericTypes';
import { IGlobalLookupResult } from '../common/models/SearchDefinitions';
import { Post } from '../util/HttpUtils';

export async function GlobalLookup(Query: string): Promise<IGlobalLookupResult | null> {
  const options: RequestOptions = {};
  return Post<IGlobalLookupResult>('api/unifiedsearch', options, { Lookup: Query });
}
